import {useState} from "react";

const normalizeStoredString = (value) => {
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (trimmed.length >= 2 && trimmed.startsWith('"') && trimmed.endsWith('"')) {
        return trimmed.slice(1, -1);
    }
    return trimmed;
};

/**
 * Configurar valores en el local storage
 * @param key
 * @param defaultValue
 * @returns {(any|setLocalStoreValue)[]}
 * @constructor
 */
export function UseLocalStorage(key, defaultValue) {
    const [storedValue, setStoreValue] = useState(() => {
        try {
            const item = localStorage.getItem(key)
            if (item == null) return defaultValue
            try {
                return normalizeStoredString(JSON.parse(item))
            } catch (e) {
                // Allow non-JSON values already stored in localStorage
                return normalizeStoredString(item)
            }
        } catch (e) {
            return defaultValue;
        }
    });
    const setLocalStoreValue = value => {
        try {
            setStoreValue(value)
            localStorage.setItem(key, JSON.stringify(value))
        } catch (e) {
            console.log(e)
        }
    }
    return [storedValue, setLocalStoreValue]
}

/**
 * Obtener los valores del local storage
 * @param key
 * @returns {any|boolean}
 */
export default function getStoredValue(key) {
    const item = localStorage.getItem(key)
    if (item == null) return false
    if (item === '' || item === 'null' || item === 'undefined') return false
    try {
        return normalizeStoredString(JSON.parse(item))
    } catch (e) {
        // Allow raw string tokens (not JSON-stringified)
        return normalizeStoredString(item)
    }
}

export function deleteStoredValue(key) {
    localStorage.removeItem(key)
    return true;
}